import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { FONT, getFont } from '@tornado-rdk/typography';
import { makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../utils/style';

export const defaultContext = makeDefaultStylingContext();

export const GAP = {
  [HD]: 24,
  [FULL_HD]: 40,
};

export const ENTRIES_GAP = {
  [HD]: 24,
  [FULL_HD]: 24,
};

export const SEPARATOR_HEIGHT = {
  [HD]: 2,
  [FULL_HD]: 4,
};

export const colors = {
  description: makeThemeColor(PRIMARY),
  separator: makeThemeColor(PRIMARY, 0.3),
};

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => {
  const descriptionFont = getFont(FONT.OTTAWA_1, screenSize);

  return {
    flex: {
      direction: 'column',
    },
    Description: {
      flexItem: {
        marginBottom: GAP[screenSize],
      },
      text: {
        ...descriptionFont,
        maxLinesSuffix: '...',
      },
    },
    Separator: {
      flexItem: {
        marginBottom: GAP[screenSize],
      },
      rect: true,
      color: colors.separator[colorMode],
      h: SEPARATOR_HEIGHT[screenSize],
    },
  };
};
